import React, { useEffect, useRef, useState } from "react";

// 3rd Party Libraries
import _ from "lodash";
import PropTypes from "prop-types";
import { DropdownButton } from "react-bootstrap";

// components
import ShowTooltip from '../Tooltip/showToolTip.jsx';

// Styles
import styles from "./moreFilter.module.scss";

const MoreFilter = ({
  name,
  optionList,
  handleOptionClick,
  selectedOptionlist,
  disabled,
  tooltip,
  tooltipText,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState(selectedOptionlist);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const dropdownRef = useRef(null);
  const rawOption = _.sortBy(optionList, "label");

  useEffect(() => {
    setSelectedOption(selectedOptionlist);
  }, [selectedOptionlist]);

  const filteredOptions = (rawOption ?? []).filter((item) =>
  (item?.label ?? "").toLowerCase().includes((searchTerm ?? "").toLowerCase())
);
  const isAllSelected =
    filteredOptions?.length > 0 &&
    selectedOption?.length === filteredOptions?.length;

  const optionClick = (optionValue) => {
    const updatedOptions = selectedOption.includes(optionValue)
      ? selectedOption.filter((value) => value !== optionValue)
      : [...selectedOption, optionValue];

    setSelectedOption(updatedOptions);
    handleOptionClick(updatedOptions);
  };

  const handleDropdownToggle = (isOpen) => {
    setIsDropdownOpen(isOpen);
    if (!isOpen) {
      setSearchTerm("");
    }
  };

  const tooltipHoverTrack = (ishover) => {
    setIsHover(ishover);
  };

  const handleSelectAll = () => {
    const visibleValues = filteredOptions.map((item) => item.value);
    const updatedOptions =
      selectedOption.length === visibleValues.length &&
        visibleValues.every((value) => selectedOption.includes(value))
        ? []
        : visibleValues;

    setSelectedOption(updatedOptions);
    handleOptionClick(updatedOptions);
  };

  const renderOverlay = () => {
    return (
      <span className={`${styles["more-field"]} d-inline-block`} tabIndex="0">
        <DropdownButton
          title={name}
          show={isDropdownOpen}
          onToggle={handleDropdownToggle}
          ref={dropdownRef}
          disabled={disabled}
          className={styles.selectbutton}
          align={"end"}
          flip={true}
          onMouseEnter={() => tooltipHoverTrack(true)}
          onMouseLeave={() => tooltipHoverTrack(false)}
        >
          <div className={styles.checkboxpad}>
            <div className="maincontainer">
              <div className="form-group has-search">
                <input
                  type="text"
                  className={`${styles["form-control"]} form-control`}
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            {optionList ? (
              filteredOptions.length === 0 ? (
                <div className={`${styles["no-results"]}mx-1 my-2`}>
                  No Result
                </div>
              ) : (
                <>
                  <div className={`${styles.selectAllMore} mx-1 my-2`}>
                    <span className={styles.selectA} onClick={handleSelectAll}>
                      {isAllSelected ? "Unselect all" : "Select all"}
                    </span>
                  </div>
                  <div className={styles.maxscroll}>
                    {filteredOptions.map((item, index) => (
                      <div key={index} className="my-2">
                        <label className={styles["checkbox-label"]}>
                          <input
                            className={`${styles["checkbox-input"]} mx-1`}
                            type="checkbox"
                            checked={selectedOption?.includes(item.value)}
                            onChange={(e) => {
                              optionClick(item.value);
                              e.stopPropagation();
                            }}
                          />{" "}
                          {item.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </>
              )
            ) : (
              <div className={`${styles["no-results"]}mx-1 my-2`}>
                No Options
              </div>
            )}
          </div>
        </DropdownButton>
      </span>
    );
  };

  return (
    <div className="checkbox-group Custom_tooltip">
      {tooltip ? (
        <span
          className="d-inline-block mb-5"
          tabIndex="0"
          onMouseEnter={() => setIsHover(true)} // Set hover state when mouse enters
          onMouseLeave={() => setIsHover(false)} // Reset hover state when mouse leaves
          ref={dropdownRef} // Attach the ref to this element
        >
          {/* Use ShowTooltip with custom class and dynamic visibility */}
          <ShowTooltip
            epssClassName="Custom_tooltip"
            value={tooltipText || ""} // Display the tooltip text
            placement="top" // Tooltip placement (adjust as needed)
            show={isHover && !isDropdownOpen} // Only show the tooltip when hovered and dropdown is not open
          />
          {/* Render the overlay or content as usual */}
          {renderOverlay()}
        </span>
      ) : (
        renderOverlay()
      )}
    </div>
  );
};

export default React.memo(MoreFilter);

MoreFilter.propTypes = {
  name: PropTypes.string.isRequired,
  optionList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleOptionClick: PropTypes.func.isRequired,
  selectedOptionlist: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.bool,
  tooltipText: PropTypes.string,
};

MoreFilter.defaultProps = {
  disabled: false,
  tooltip: false,
  tooltipText: "",
};



